import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTheme } from '@/context/ThemeContext'
import Footer from '@/components/Frontside/Footer'
import ProjectDetailRich from '@/components/project-detail/ProjectDetailRich'
import { supabase } from '@/lib/supabase'
import { normalizeHubPublicProject } from '@/lib/projectDisplay'

export default function ShareHubProjectPage() {
  const { token } = useParams()
  const { setTheme } = useTheme()
  const [project, setProject] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    setTheme('light')
  }, [setTheme])

  useEffect(() => {
    if (!token) return
    let cancelled = false
    ;(async () => {
      setLoading(true)
      setError(null)
      const { data, error: rpcErr } = await supabase.rpc('get_hub_project_by_share_token', {
        p_token: token,
      })
      if (cancelled) return
      if (rpcErr) {
        setError(rpcErr.message)
        setProject(null)
      } else if (!data) {
        setError('This share link is invalid or expired.')
        setProject(null)
      } else {
        setProject(data)
      }
      setLoading(false)
    })()
    return () => {
      cancelled = true
    }
  }, [token])

  if (loading) {
    return (
      <div className="frontside-page flex min-h-screen flex-col bg-background text-foreground">
        <p className="flex flex-1 items-center justify-center text-muted-foreground">Loading…</p>
      </div>
    )
  }

  if (error || !project) {
    return (
      <div className="frontside-page flex min-h-screen flex-col bg-background text-foreground">
        <div className="flex flex-1 flex-col items-center justify-center px-4">
          <p className="text-destructive text-sm">{error || 'Not found'}</p>
        </div>
        <Footer />
      </div>
    )
  }

  const detail = normalizeHubPublicProject(project)

  return (
    <>
      <ProjectDetailRich detail={detail} backTo={{ to: '/', label: '← Home' }} />
      <Footer />
    </>
  )
}
